import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import useStyles from './../styles';
import { useFormik } from 'formik';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { toast } from '@livable/saas-react-components';
import { TextField, Button } from '@mui/material';
import { BackdropLoader } from '@livable/saas-react-components';
import { EditAppfolioSchema } from 'src/utils/formValidation/Appfolio';

// Credential-local edit: name, client id, client secret. Company, address and account-holder details are
// edited on the company pages. The secret arrives masked from the API; an untouched mask is byte-identical
// to the prefill and is never sent.
export const EditModalForm = observer(_ref => {
  let data = _ref.data,
    callback = _ref.callback,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState({
      name: '',
      clientId: '',
      clientSecret: ''
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    initialValues = _useState4[0],
    setInitialValues = _useState4[1];
  const formik = useFormik({
    initialValues,
    validationSchema: EditAppfolioSchema,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: async values => {
      const requestData = {};
      if (values.name !== initialValues.name) requestData.name = {
        value: values.name
      };
      if (values.clientId !== initialValues.clientId) requestData.clientId = {
        value: values.clientId
      };
      if (values.clientSecret !== initialValues.clientSecret) requestData.clientSecret = {
        value: values.clientSecret
      };
      if (Object.keys(requestData).length === 0) {
        handleModalClose();
        return;
      }
      setIsLoading(true);
      try {
        const resp = await store.credentials.patchCredentialsAsync.run({
          credentialsId: data.id,
          requestData
        });
        if (resp && resp.isSuccessful) {
          toast('success', {
            body: ['Successfully saved']
          });
          await callback();
          handleModalClose();
        }
      } finally {
        setIsLoading(false);
      }
    }
  });
  useEffect(() => {
    var _data$name, _data$clientId, _data$clientSecret;
    setInitialValues({
      name: (_data$name = data.name) !== null && _data$name !== void 0 ? _data$name : '',
      clientId: (_data$clientId = data.clientId) !== null && _data$clientId !== void 0 ? _data$clientId : '',
      clientSecret: (_data$clientSecret = data.clientSecret) !== null && _data$clientSecret !== void 0 ? _data$clientSecret : ''
    });
    formik.setFieldTouched('name', true);
    formik.setFieldTouched('clientId', true);
    formik.setFieldTouched('clientSecret', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  const renderField = (id, label) => /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t(label),
    variant: "outlined",
    fullWidth: true,
    id: id,
    name: id,
    value: formik.values[id],
    onBlur: formik.handleBlur,
    onChange: formik.handleChange,
    error: formik.touched[id] && Boolean(formik.errors[id]),
    helperText: formik.touched[id] && t(formik.errors[id], t)
  }));
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.modalBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapper
  }, renderField('clientId', 'Client Id'), renderField('clientSecret', 'Client Secret'), renderField('name', 'Credential Name'))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    disabled: !formik.isValid || isLoading,
    variant: "priority",
    'custom-attribute': '521-appfolio-page'
  }, t('Save'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.credentials.patchCredentialsAsync.inProgress
  }));
});